import React from 'react';
import tpl from '../templates/sepa-new';
import BaseNewCardView from '../../../../Cards/views/BaseNewCardView';

export default class extends BaseNewCardView {
    templates = {
        [this.uiStates.INITIAL]: tpl,
        [this.uiStates.INTERACTIVE]: tpl,
        [this.uiStates.ERROR]: tpl,
        [this.uiStates.STANDBY]: tpl
    };

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            ui: this.uiStates.INITIAL
        };
    }

    static displayName = 'Transfers.Views.Sepa';
}
